import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './GuildWarCount.css';

const GuildWar = () => {
  const [guildName, setGuildName] = useState('');
  const [gid, setGid] = useState('');
  const [defenders, setDefenders] = useState([]);
  const [event, setEvent] = useState('null');
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: 'pvpLeaguePhase', direction: 'ascending' });
  
  const [selectedDefender, setSelectedDefender] = useState(null);
  const [lineName, setLineName] = useState('');
  const [group, setGroup] = useState('');
  const [bulkLineName, setBulkLineName] = useState('-'); // 一括設定用のlineName
  const [bulkGroup, setBulkGroup] = useState('-');       // 一括設定用のgroup

  // 一括更新用のハンドラー関数
  const handleBulkUpdate = async () => {
    try {
      // すべてのメンバーのUIDに対して更新リクエストを送信
      for (const defender of defenders) {
        await axios.put(`https://rangers-api-3mfw.onrender.com/api/guilds/update-line-group`, {
          uid: defender.uid,
          lineName: bulkLineName,
          group: bulkGroup,
        });
      }
      // 更新後のデータを再取得
      fetchGuildWarData();
      setBulkLineName(''); // フォームをリセット
      setBulkGroup('');
    } catch (error) {
      console.error('Bulk update error:', error);
    }
  };

  const fetchGuildWarData = async () => {
    setIsLoading(true);
    try {
      setIsError(false);

      const response = await axios.get(
        `https://rangers-api-3mfw.onrender.com/api/guild-info-cma/00e6947f32afa26dc1dfcc19f1a2628e/members`,
        {
          params: {
            eventType: event,
          },
        }
      );

      const data = response.data.map(defender => ({
        ...defender,
        pvpLeaguePhase: translatePvpLeaguePhase(defender.pvpLeaguePhase),
      }));

      setDefenders(data);
    } catch (error) {
      setIsError(true);
      console.error('データの取得中にエラーが発生しました:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGuildWarData();
  }, [gid, event]);

  useEffect(() => {
    if (defenders.length > 0) {
      setSortConfig({ key: 'pvpLeaguePhase', direction: 'ascending' });
    }
  }, [defenders]);

  const translateLevel = (level) => {
    if (level >= 1 && level <= 99) {
      return `${level}`;
    } else if (level >= 100 && level <= 198) {
      return `M${level - 99}`;
    } else if (level >= 199 && level <= 297) {
      return `S${level - 198}`;
    } else if (level >= 298 && level <= 396) {
      return `U${level - 297}`;
    } else if (level >= 397 && level <= 495) {
      return `L${level - 396}`;
    } else if (level >= 496) {
      return `S'${level - 495}`;
    } else {
      return 'unknown';
    }
  };

  const translatePvpLeaguePhase = (phase) => {
    switch (phase) {
      case 'LEGEND': return 'L';
      case 'MASTER_1': return 'M1';
      case 'MASTER_2': return 'M2';
      case 'MASTER_3': return 'M3';
      case 'DIAMOND_1': return 'D1';
      case 'DIAMOND_2': return 'D2';
      case 'DIAMOND_3': return 'D3';
      case 'GOLD_1': return 'G1';
      case 'GOLD_2': return 'G2';
      case 'GOLD_3': return 'G3';
      case 'SILVER_1': return 'S1';
      case 'SILVER_2': return 'S2';
      case 'SILVER_3': return 'S3';
      case 'BRONZE': return 'B';
      default: return phase;
    }
  };

  const sortPvpLeaguePhase = (phaseA, phaseB) => {
    const order = ['L', 'M1', 'M2', 'M3', 'D1', 'D2', 'D3', 'G1', 'G2', 'G3', 'S1', 'S2', 'S3', 'B'];
    
    const indexA = order.indexOf(phaseA);
    const indexB = order.indexOf(phaseB);

    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  };

  const sortedDefenders = [...defenders].sort((a, b) => {
    const { key, direction } = sortConfig;
    const order = direction === 'ascending' ? 1 : -1;

    try {
      if (key === 'level') {
        return order * ((a.level || 0) - (b.level || 0));
      } else if (key === 'userName') {
        return order * (a.userName || '').localeCompare(b.userName || '');
      } else if (key === 'pvpLeaguePhase') {
        return order * sortPvpLeaguePhase(a.pvpLeaguePhase || '', b.pvpLeaguePhase || '');
      } else if (key === 'lineName') {
        return order * (a.lineName || '').localeCompare(b.lineName || '');
      } else if (key === 'group') {
        return order * (a.group || '').localeCompare(b.group || '');
      }
      return 0;
    } catch (error) {
      console.error('Sorting error:', error);
      return 0; // エラーが発生した場合は、元の順序を保持
    }
  });

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? '↑' : '↓';
    }
    return '⇅'; // デフォルトの矢印アイコン
  };

  const handleUpdate = async () => {
    if (selectedDefender) {
      try {
        await axios.put(`https://rangers-api-3mfw.onrender.com/api/guilds/update-line-group`, {
          uid: selectedDefender.uid,
          lineName: lineName,
          group: group,
        });
        //fetchGuildWarData(); // データを再取得
        setLineName('');
        setGroup('');
        setSelectedDefender(null);
      } catch (error) {
        console.error('Update error:', error);
      }
    }
  };

  return (
    <div className="guild-war-container">
      <div className="select-group">
        <h1>ドリチー Info</h1>
      </div>

      {isError ? (
        <p>An error occurred while retrieving data. Please try again.</p>
      ) : isLoading ? (
        <p>Loading data...(It may take several minutes)</p>
      ) : (
        <>
          <br />
          <table className="defender-table">
            <thead>
              <tr>
                <th onClick={() => requestSort('level')}>Level {getSortIcon('level')}</th>
                <th onClick={() => requestSort('userName')}>Name {getSortIcon('userName')}</th>
                <th onClick={() => requestSort('pvpLeaguePhase')}>PVP {getSortIcon('pvpLeaguePhase')}</th>
                <th onClick={() => requestSort('lineName')}>攻撃対象 {getSortIcon('lineName')}</th>
                <th onClick={() => requestSort('group')}>その他 {getSortIcon('group')}</th>
              </tr>
            </thead>
            <tbody>
              {sortedDefenders.map((defender) => {
                const userLevel = translateLevel(defender.level || 0);
                const playerName = defender.userName || 'unknown';
                const pvpLeaguePhase = defender.pvpLeaguePhase || 'unknown';
                const lineName = defender.lineName || 'unknown';
                const group = defender.group || 'unknown';

                return (
                  <tr key={defender.uid} className="defender-row" onClick={() => {
                    setSelectedDefender(defender);
                    setLineName(defender.lineName);
                    setGroup(defender.group);
                  }}>
                    <td>{userLevel}</td>
                    <td>{playerName}</td>
                    <td>{pvpLeaguePhase}</td>
                    <td>{lineName}</td>
                    <td>{group}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {selectedDefender && (
  <div className="update-form">
    <h2>Updating: {selectedDefender.userName}</h2>
    <select value={lineName} onChange={(e) => setLineName(e.target.value)}>
          <option value="">選択</option>
          <option value="-">-</option>
          <option value="待機">待機</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
    </select>
    <input
      type="text"
      value={group}
      onChange={(e) => setGroup(e.target.value)}
      placeholder="その他"
    />
    <button onClick={handleUpdate}>更新</button>
    <br />
          <div className="bulk-update-form">
            <h2>一括更新</h2>
            <select value={bulkLineName} onChange={(e) => setBulkLineName(e.target.value)}>
              <option value="">選択</option>
              <option value="-">-</option>
              <option value="待機">待機</option>
            </select>
            <input
              type="text"
              value={bulkGroup}
              onChange={(e) => setBulkGroup(e.target.value)}
              placeholder="その他"
            />
            <button onClick={handleBulkUpdate}>一括更新</button>
          </div>
  </div>
)}
          <br />
        </>
      )}
    </div>
  );
};

export default GuildWar;
